import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="pt-40 pb-24 md:pt-48 md:pb-32 px-6 md:px-12 max-w-7xl mx-auto min-h-[90vh] flex flex-col justify-center" data-id="element-72">
      <div className="grid md:grid-cols-12 gap-12 items-center" data-id="element-73">
        <motion.div className="md:col-span-7 lg:col-span-6 flex flex-col gap-8" initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} data-id="element-74">
          <h1 className="text-5xl md:text-6xl lg:text-7xl leading-[1.1] text-navy font-serif tracking-wide" data-id="element-75">
            Private homes, shared spaces, and community from the start.
          </h1>
          <p className="text-lg md:text-xl text-navy/80 leading-relaxed max-w-lg font-light" data-id="element-76">
            Familiar Spaces is building Mexico City's first co-housing
            community. One that starts before the building does, designed by the
            people living in it.
          </p>
          <div className="flex flex-wrap gap-4 pt-4" data-id="element-77">
            <a href="#join" className="px-8 py-3.5 bg-marigold text-navy rounded-full font-medium hover:bg-marigold/90 transition-colors text-center" data-id="element-78">
              Join the community
            </a>
            <Link to="/events" className="px-8 py-3.5 border border-navy text-navy rounded-full font-medium hover:bg-navy/5 transition-colors text-center" data-id="element-79">
              Join an event
            </Link>
          </div>
        </motion.div>

        <motion.div className="md:col-span-5 lg:col-span-6 flex flex-col gap-4" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.2,
        ease: [0.16, 1, 0.3, 1]
      }} data-id="element-80">
          <div className="relative h-[400px] md:h-[500px] w-full rounded-xl overflow-hidden border border-navy/10" data-id="element-81">
            <img src="https://cdn.prod.website-files.com/69d7485bafb858ee1bc05b17/69da6fdf4499d9a0908bacb1_00_Kids%20in%20Courtyard.png" alt="Kids playing in the shared courtyard" className="absolute inset-0 w-full h-full object-cover" data-id="element-82" />
          </div>
          <div className="grid grid-cols-3 gap-4" data-id="element-83">
            <div className="relative h-24 md:h-32 rounded-xl overflow-hidden border border-navy/10" data-id="element-84">
              <img src="https://cdn.prod.website-files.com/69d7485bafb858ee1bc05b17/69da6fea4edb131065ab6206_00_kitchen.png" alt="Shared kitchen space" className="absolute inset-0 w-full h-full object-cover" data-id="element-85" />
            </div>
            <div className="relative h-24 md:h-32 rounded-xl overflow-hidden border border-navy/10" data-id="element-86">
              <img src="https://cdn.prod.website-files.com/69d7485bafb858ee1bc05b17/69f1f46fbc38a0affa8a869c_00_Main%20building%20another%20level%20w%20people.png" alt="Main building exterior with people" className="absolute inset-0 w-full h-full object-cover" data-id="element-87" />
            </div>
            <div className="relative h-24 md:h-32 rounded-xl overflow-hidden border border-navy/10" data-id="element-88">
              <img src="https://cdn.prod.website-files.com/69d7485bafb858ee1bc05b17/69da6f865353f35677f550b6_00_Family%20at%20Table%20in%20Entrance_upgraded.png" alt="Family at table in entrance" className="absolute inset-0 w-full h-full object-cover" data-id="element-89" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}